import React, { TextareaHTMLAttributes } from "react";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export default function Textarea({ className = "", ...props }: TextareaProps) {
  const baseClasses =
    "w-full rounded-xl border border-gray-200 px-5 py-4 text-sm text-[#0A2B1C] placeholder:text-gray-400 focus:border-[#063B66] focus:outline-none focus:ring-1 focus:ring-[#063B66]/20 bg-white transition-all disabled:opacity-50 disabled:bg-gray-50 resize-none";

  const combinedClasses = `${baseClasses} ${className}`.trim();

  return <textarea className={combinedClasses} {...props} />;
}
